import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";
import BasicButtons from "../../UI/BasicButtons";
import { styled } from "@mui/material";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ScrollDialog from "../../UI/ScrollModal";
import Files from "../../UI/Files";

function Row({ row }) {
  const [openFirst, setOpenFirst] = React.useState(false);
  const [filesIsOpen, setFilesIsOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenFirst(!openFirst)}
          >
            {openFirst ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.attributes.nomenklatura.data[0].attributes.name}
        </TableCell>
        <TableCell align="center">
          {row.attributes.nomenklatura.data[0].attributes.square} кв.м.
        </TableCell>
        <TableCell align="center">
          {row.attributes.nomenklatura.data[0].attributes.inventNumber}
        </TableCell>
        <TableCell align="center">
          {row.attributes.nomenklatura.data[0].attributes.address +
            " " +
            row.attributes.nomenklatura.data[0].attributes.addressNumber}
        </TableCell>
        <ButtonTableStyled align="center">
          <BasicButtons>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.google.com/maps?q=${row.attributes.nomenklatura.data[0].attributes.coordinates}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              на карте
            </a>
          </BasicButtons>
        </ButtonTableStyled>
      </TableRow>
      <TableRow style={{ backgroundColor: "#bbb6b622" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openFirst} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Договор
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>№</TableCell>
                    <TableCell>Файлы</TableCell>
                    <TableCell>Дата начало</TableCell>
                    <TableCell>Дата окончания</TableCell>
                    <TableCell>Лицевой счет</TableCell>
                    <TableCell>Сумма налога</TableCell>
                    <TableCell>Сумма договора</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {"Договор №" +
                        row.attributes.numberDogovor +
                        " от " +
                        convertToRuFormat(row.attributes.docDate)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <FilePresentIcon
                        onClick={() => setFilesIsOpen(true)}
                        style={{ cursor: "pointer" }}
                      />
                      <ScrollDialog
                        open={filesIsOpen}
                        closeModal={() => setFilesIsOpen(false)}
                        title={row.attributes.attachments ? "Файлы" : "Нет загруженных файлов"}
                      >
                        <Files
                          uploadedFiles={[]}
                          attachments={row.attributes.attachments ? row.attributes.attachments : []}
                        />{" "}
                      </ScrollDialog>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {convertToRuFormat(row.attributes.dateDogovorFrom)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {convertToRuFormat(row.attributes.dateDogovorTo)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.invoice}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.nalog + " сом"}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.totalSum + " сом"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
export default function CollapsibleTable({ rows }) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Typography variant="h6" gutterBottom component="div">
                  Номенклатура
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6" gutterBottom component="div">
                  Площадь
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6" gutterBottom component="div">
                  Идентификационный код
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6" gutterBottom component="div">
                  Адрес
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6" gutterBottom component="div">
                  Местоположение
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <Row key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
const ButtonTableStyled = styled(TableCell)`
  display: flex;
  justify-content: center;
`;
